<div class="loader-container {{extraCssClass}}" [ngClass]="{'loader-container--is-loading': isLoading}">
  <mat-spinner [diameter]="40" color="accent" *ngIf="isLoading" class="loader-container__spinner"></mat-spinner>
  <ng-container *ngIf="isContentVisible">
    <ng-content select="[loadedComponent]"></ng-content>
  </ng-container>
</div>
